module.exports = __webpack_public_path__ + "img/icon-blueprint.ef378b33.svg";